import { createContext, useContext } from "react";
import { Amplify } from "aws-amplify";
import {
  useEnvironmentConfig,
  type Environment,
  type Feature,
  hasFeature,
} from "@/queries/environment/useEnvironmentConfig";

export { type Feature, type Environment, hasFeature };

const EnvironmentContext = createContext<Environment | undefined | null>(null);

export default function EnvironmentContextProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { data } = useEnvironmentConfig({
    queryConfig: {
      select: (environment) => {
        // Configure Amplify with AWS exports
        if (environment.awsExports) {
          Amplify.configure(environment.awsExports);

          // const updatedAWSExports = {
          //   ...environment.awsExports,
          //   oauth: {
          //     ...environment.awsExports.oauth,
          //     redirectSignIn: "http://localhost:8443/auth/redirect/",
          //     redirectSignOut: "http://localhost:8443/auth/signout/",
          //   },
          // };
          // Amplify.configure(updatedAWSExports);
        }

        return environment;
      },
    },
  });

  return (
    <EnvironmentContext.Provider value={data}>
      {children}
    </EnvironmentContext.Provider>
  );
}

// checks if context is null
export function useInitialEnvironmentContext() {
  const context = useContext(EnvironmentContext);

  if (context === null) {
    throw new Error(
      "useInitialEnvironmentContext must be used within an EnvironmentProvider, and initialised"
    );
  }

  return context;
}

// once environment has been loaded, returns the environment directly
export function useEnvironmentContext() {
  const context = useContext(EnvironmentContext);

  if (!context) {
    throw new Error(
      "useEnvironmentContext must be used within an EnvironmentProvider"
    );
  }

  return context;
}
